import React from 'react';
import { Outlet } from 'react-router-dom';

const EspaceSupplierLayout: React.FC = () => {
  return <Outlet />;
};

EspaceSupplierLayout.displayName = 'EspaceSupplierLayout';

export default EspaceSupplierLayout;
